import { Title } from '@/components/phone/Title';
import { GiftIcon, PhonePhoneIcon } from '@raysee/icon';
import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import Image from 'next/image';
import { Container, Footer, Header, Main, TabMenu, withLayout } from '../../../components';
import { useCurrentUser } from '@/hooks';

const Page: NextPage = () => {
  const { user } = useCurrentUser();

  return withLayout(
    <Container>
      <NextSeo
        title="料金案内と支払い方法｜電話占いRAYSEE｜4,200円分無料、1分220円~｜口コミで当たると評判の電話レイシー"
        description="電話占いRAYSEEの料金・支払方法の説明ページです。クレジットカード、銀行振込がご利用できます。後払いも可能でお客様の状況に合わせてご利用することができます。"
      />
      <Header />
      <Main>
        <section className="my-8">
          <Title title="料金相談とお支払いに関して" isCenter />
        </section>
        <Image src={'/images/phone/hr/0_50p.png'} alt="" width="1560" height="208" />

        <section className="bg-phone-bg2 text-phone-primary font-bold py-10 font-serif">
          <h1 className="text-3xl font-bold text-center">1分220円～利用可能！</h1>
          <p className="my-6 mx-10 font-bold text-center">
            24時間365日、実力屈指の占い師があなたの相談をお待ちしております。
          </p>

          <p className="mx-10 font-bold text-center">初めての方なら4200円分の鑑定が無料！</p>
          <p className="mx-10 font-bold text-center">RAYSEEだからできる得点をご用意しました。</p>
        </section>
        <Image src={'/images/phone/hr/50p_0.png'} alt="" width="1560" height="208" />

        <section className="m-5">
          <div className="bg-phone-primary py-5 rounded">
            <h2 className="text-white text-3xl font-bold text-center font-serif">特典1</h2>

            <div className="bg-white rounded-lg m-5 mb-0 py-5 flex">
              <PhonePhoneIcon width={36} height={36} className="mx-3" />
              <div className="flex items-end space-x-2">
                <p className="text-brand">
                  <span className="text-2xl font-bold">2,200</span>
                  <span className="text-xl font-bold">円分</span>
                </p>
                <p className="font-bold">電話占い無料！</p>
              </div>
            </div>
          </div>
          <div className="mt-3 font-bold text-sm">
            <p>※初めての方に限り、お一人様1回限り</p>
          </div>
        </section>

        <section className="m-5">
          <div className="bg-phone-primary py-5 rounded">
            <h2 className="text-white text-3xl font-bold text-center font-serif">特典2</h2>

            <div className="bg-white rounded-lg m-5 mb-0 py-5 flex">
              <div className="flex items-center">
                <GiftIcon width={36} height={36} className="text-phone-primary mx-3" />
              </div>
              <div>
                <p className="font-bold">今だけ限定でチャット占いのクーポンを</p>
                <p>
                  <span className="text-2xl font-bold text-brand">1000円分 x 2枚</span>
                  <span className="font-bold ml-2">プレゼント!!</span>
                </p>
              </div>
            </div>
          </div>
          <div className="mt-3 font-bold text-sm">
            <p>※電話占いを利用された方限定の特典です</p>
            <p>※1度のご鑑定で2000円以上の場合のみご利用可能です</p>
          </div>
        </section>

        <section className="m-5">
          <div className="rounded border-4 border-[#c599db] p-6">
            <div className="flex space-x-3 text-phone-brand text-xl font-serif font-black">
              <div className="h-14 w-14 items-center">
                <Image src={'/images/phone/price/yen_mark.png'} alt="" width="224" height="225" />
              </div>
              <div>
                <div>料金のお支払いは後払いでもOK</div>
                <div>安心してご利用いただけます。</div>
              </div>
            </div>
            <hr className="my-6" />
            <div className="justify-items-center space-y-6">
              <p className="text-brand text-xl font-black">＜料金例＞</p>
              <div className="justify-items-center">
                <div>20分の鑑定の場合</div>
                <div>20分×220円=4,400円のご利用料金となります。</div>
              </div>
              <div className="text-center">
                ※1分未満の通話時間は切り上げとなりますので、あらかじめご了承ください。
              </div>
            </div>
          </div>
        </section>

        <Image src={'/images/phone/hr/0_50p.png'} alt="" width="1560" height="208" />

        <section className="bg-phone-bg2 font-bold py-10 p-5">
          <h1 className="text-3xl font-bold text-center text-phone-primary font-serif">
            お支払方法
          </h1>

          <div className="rounded border-4 border-white mt-4 justify-items-center	space-y-3 py-3">
            <h2 className="text-xl">1.クレジットカート</h2>
            <div className="flex items-center space-x-4">
              <Image
                src={'/images/phone/price/visa.png'}
                className="w-16"
                alt=""
                width="256"
                height="85"
              />
              <Image
                src={'/images/phone/price/americanexpress.png'}
                className="w-16"
                alt=""
                width="256"
                height="251"
              />
              <Image
                src={'/images/phone/price/jcb.png'}
                className="w-16"
                alt=""
                width="256"
                height="194"
              />
            </div>
            <div className="flex items-center space-x-4">
              <Image
                src={'/images/phone/price/mastercard.png'}
                className="w-16"
                alt=""
                width="256"
                height="103"
              />

              <Image
                src={'/images/phone/price/diners.png'}
                className="w-16"
                alt=""
                width="256"
                height="181"
              />
            </div>
          </div>

          <div className="rounded border-4 border-white mt-4 justify-items-center	space-y-3 p-3">
            <h2 className="text-xl">2.銀行後払い</h2>
            <div className="flex items-center">
              <Image
                src={'/images/phone/price/bank.png'}
                className="w-16"
                alt=""
                width="252"
                height="248"
              />
            </div>
            <p className="text-sm font-normal">
              ※18歳未満のご利用者様は銀行後払いをご利用いただけません。
            </p>
          </div>
        </section>
        <Image src={'/images/phone/hr/50p_0.png'} alt="" width="1560" height="208" />

        <div className="h-20" />
        <div className="h-20 bg-[#3d2748]" />
        <Footer />
      </Main>
      <TabMenu isLogin={!!user} />
    </Container>,
  );
};

export default Page;
